/**
 * Where the API lives, for URLs the browser *navigates* to or loads as media rather than
 * fetches through the typed client: Google sign-in, checkout, an `<audio>` source. A relative
 * `/api/...` there would land on the SPA's own host, which on the beta (app.ringout.ai,
 * Cloudflare) serves only the app and no API.
 *
 * Dev: `VITE_API_BASE_URL` is unset, the base is '' and the Vite proxy handles `/api`.
 * Beta: the build sets it to the API origin, e.g. `https://api.ringout.ai` (no trailing slash,
 * no `/api`).
 */
export function apiBaseUrl(raw: string | undefined = import.meta.env.VITE_API_BASE_URL): string {
  return (raw ?? '').trim().replace(/\/+$/, '')
}

/** An absolute URL on the API for a path that already starts with `/api`. */
export function apiUrl(path: string): string {
  return `${apiBaseUrl()}${path}`
}
